module.exports = "<div class=\"label-filters\" *ngIf=\"filters.length > 0\"><span class=\"label-filter\" *ngFor=\"let filter of filters\">{{ filter.label }}<span class=\"label-filter__remove\" (click)=\"removeFilter(filter)\"></span></span></div>"


//////////////////
// WEBPACK FOOTER
// ./app/common/search/label-filters.component.html
// module id = 1125
// module chunks = 4